import CryptoJS from 'crypto-js';
import * as Const from './Const';
import axios from 'axios';

export const GetKeyEndTypes = (input: string[]): number[] => {
  return input
    ? input.map((typeName: string) => {
        const type = Const.EndTypes.find((t) => t.name === typeName);
        return type ? type.id : -1; // 見つからない場合は-1を返す
      })
    : [];
};

export const GetSummaryRuleOptionId = (input: string): number => {
  const type = Const.SummaryRuleOption.find((t) => t.value === input);
  return type ? Number(type.key) : -1; // 見つからない場合は-1を返す
};

export const GetSummaryRuleOptionName = (input: number): string => {
  const type = Const.SummaryRuleOption.find((t) => Number(t.key) === input);
  return type ? type.value : ''; // 見つからない場合はブランクを返す
};

export const GetErrorMessages = (input: string): string => {
  if (!input) return '';
  const type = Const.AwsErrorMessages.find((t) => t.orgMsg === input);
  return type ? type.msg : '';
};

export async function fetchTokenAndOrgId(username: string): Promise<{ isGetOrgId: boolean }> {
  const orgIdDataUrl = `${import.meta.env.VITE_DATA_POOLS_AUTH_URL}/selectSupportSiteUserData`;
  const postParams = { [Const.KeyUserName]: username };

  let orgId = '';
  let isGetOrgId = false;

  const orgIdRes = await axios.post(orgIdDataUrl, postParams);
  const responseData = orgIdRes.data?.[0];

  if (responseData && responseData.is_dashboard_enabled === Const.KeyIsDashboardEnabled) {
    orgId = responseData.organization;
    const encryptedOrgId = CryptoJS.AES.encrypt(
      orgId,
      import.meta.env.VITE_ENV_SESSION_DATA_KEY
    ).toString();
    localStorage.setItem(Const.KeySessionBaseData, encryptedOrgId);
    isGetOrgId = true;
  }

  return { isGetOrgId };
}

export const GetOrgId = (): string => {
  let orgId = Const.KeyInvalidOrgId;

  const sessionData = localStorage.getItem(Const.KeySessionBaseData);
  if (sessionData) {
    orgId = CryptoJS.AES.decrypt(sessionData, import.meta.env.VITE_ENV_SESSION_DATA_KEY).toString(
      CryptoJS.enc.Utf8
    );
  }
  return orgId;
};

export function formatDateToString(date?: Date): string {
  const d = date ?? new Date();
  const pad = (n: number) => n.toString().padStart(2, '0');
  return (
    d.getFullYear().toString() +
    pad(d.getMonth() + 1) +
    pad(d.getDate()) +
    'T' +
    pad(d.getHours()) +
    pad(d.getMinutes()) +
    pad(d.getSeconds())
  );
}
